// Copyright (c) 2017 Deere & Company

export default [
    ['claimNumber'],
    ['pin'],
    ['creditMemoNumber'],
    ['workOrder']
];



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/constants/filter-options.js